import React from 'react'
import ClientTicketModal from './client-ticket-modal.component'
import ModalConfirmation from './../../../../../components/modal/modal-confirmation.component'
import { connect } from 'react-redux'
import { toastActions } from '../../../../../actions'
import { setUserPermissions } from '../../../../../helpers'
import { bindActionCreators } from 'redux'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'

class ClientTicketModalComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isModalOpen: false,
			isQRCodeModalOpen: false
		}
		this.onReturn = onReturn.bind(this)
	}

	componentDidMount() {
		const { user } = this.props
		setUserPermissions(user)
	}

	render() {
		const {
			order,
			tickets,
			isAdmin,
			pixData,
			sourceCall,
			isModalOpen,
			isLoadingData,
			promotionCoupon,
			isQRCodeModalOpen
		} = this.props
		const hasTicketsToShow = tickets && tickets.length

		return (
			<React.Fragment>
				<ClientTicketModal
					isAdmin={isAdmin}
					order={order}
					tickets={tickets}
					sourceCall={sourceCall}
					onReturn={this.onReturn}
					pixData={pixData}
					promotionCoupon={promotionCoupon}
					closeModal={this.props.closeModal}
					hasTicketsToShow={hasTicketsToShow}
					isModalOpen={isModalOpen && !isLoadingData}
					isQRCodeModalOpen={isQRCodeModalOpen && !isLoadingData}
				/>
			</React.Fragment>
		)
	}
}

function onReturn(ticketId, cancelAll, isGoing) {
	const returnTicketPromise = this.props.isAdmin
		? this.props.returnTicketAsAdmin(ticketId, cancelAll, isGoing)
		: this.props.returnTicket(ticketId, cancelAll, isGoing)

	returnTicketPromise
		.then(({ success, errors }) => {
			if (success) {
				this.props.toastSuccess({
					message: 'Cancelamento realizado com sucesso!'
				})
				this.props.handleCancelTicket()
			} else {
				this.props.toastError({
					message: (errors && errors.pop()) || 'Erro ao realizar cancelamento'
				})
			}
		})
		// Falha do cancelamento novo (MuviHub) rejeita a promise; a mensagem
		// real da API já foi mostrada pelo interceptor central (axios.service.js).
		.catch(() => {})
}

// TODO: utilizar selectors
const mapStateToProps = ({ clientTicketModal, client, user }) => ({
	user,
	order: clientTicketModal.order,
	tickets: clientTicketModal.tickets,
	pixData: clientTicketModal.pixData,
	isLoadingData: clientTicketModal.isLoading,
	isModalOpen: clientTicketModal.isModalOpen,
	promotionCoupon: clientTicketModal.promotionCoupon,
	isQRCodeModalOpen: clientTicketModal.isQRCodeModalOpen,
	isAdmin: client.clientPointsWasLoaded && client.expiringPoints === null
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			closeModal: ClientTicketModalCreators.closeModal,
			returnTicket: ClientTicketModalCreators.returnTicket,
			returnTicketAsAdmin: ClientTicketModalCreators.returnTicketAsAdmin
		},
		dispatch
	)

const ClientTicketModalContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ClientTicketModalComponent)

export default ClientTicketModalContainer
